var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 6a1.999 1.999 0 1 0 0-4 1.999 1.999 0 1 0 0 4m-5.997 8h11.994c-.016-.04-.07-.131-.228-.277-.295-.273-.8-.58-1.511-.864C10.832 12.29 9.085 12 8 12s-2.832.288-4.258.86c-.71.284-1.216.59-1.511.863-.158.146-.212.237-.228.277M0 16v-2c0-2.66 5.33-4 8-4s8 1.34 8 4v2zM12 4c0 2.21-1.79 4-4 4S4 6.21 4 4s1.79-4 4-4 4 1.79 4 4",
    clipRule: "evenodd"
  })));
};
export default SvgUser;